module.exports = __webpack_public_path__ + "img/gartek-services-plumbing-hvac.24885280.png";